import { Tooltip } from '@liveauctioneers/hammer-ui-core/tooltip';

import useIsNarrowerThan from '@/hooks/useIsNarrowerThan';
import { mergedCaterwaulAndHammerUIThemes } from '@/theme/mergedCaterwaulAndHammerUIThemes';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

type WhyCantRetractBidPopoverProps = {
    newItemCardCTA?: boolean;
};

export const WhyCantRetractBidPopover = ({ newItemCardCTA }: WhyCantRetractBidPopoverProps) => {
    const formatMessage = useAppFormatMessage();
    const {
        breakpoints: { tabletNarrowWidthNum },
    } = mergedCaterwaulAndHammerUIThemes;
    const isMobile = useIsNarrowerThan(tabletNarrowWidthNum + 1);

    const newMyBidsItemCardText = () => {
        if (newItemCardCTA) {
            if (isMobile) {
                return 'retract';
            }
            return 'retract_bid';
        } else {
            return 'retract';
        }
    };

    return (
        <>
            <div id="why-cant-i-retract">{formatMessage([newMyBidsItemCardText()])}</div>
            <Tooltip anchorSelect="#why-cant-i-retract">
                {formatMessage(['why_cant_i_retract_bid_popover_text'])}
            </Tooltip>
        </>
    );
};
